// MutationObserver reports repeated style assignments even when nothing changed.
// Compare each attribute's first old value with its final value for the batch.
export function hasLayoutMutation(records) {
  const attributes = new Map();
  for (const record of records) {
    if (record.type !== 'attributes') return true;
    let seen = attributes.get(record.target);
    if (!seen) attributes.set(record.target, seen = new Map());
    if (!seen.has(record.attributeName)) seen.set(record.attributeName, record.oldValue);
  }
  for (const [target, values] of attributes) {
    for (const [name, oldValue] of values) {
      if (target.getAttribute(name) !== oldValue) return true;
    }
  }
  return false;
}
